import request from '@/utils/request'

// 获取快照列表
export function getSnapshotList(data) {
  return request({
    url: '/admin/asset_snapshot/getlist',
    method: 'get',
    params: data
  })
}

// 获取单个快照详情
export function getSnapshotOne(data) {
  return request({
    url: '/admin/asset_snapshot/getone',
    method: 'get',
    params: data
  })
}

// 对比两个快照
export function compareSnapshots(data) {
  return request({
    url: '/admin/asset_snapshot/compare',
    method: 'get',
    params: data
  })
}

// 根据订单号查询快照
export function getSnapshotByOrder(data) {
  return request({
    url: '/admin/asset_snapshot/getByOrder',
    method: 'get',
    params: data
  })
}

// 获取异常统计
export function getAbnormalStats(data) {
  return request({
    url: '/admin/asset_snapshot/getAbnormalStats',
    method: 'get',
    params: data
  })
}

// 查找突变点
export function findAnomalies(data) {
  return request({
    url: '/admin/asset_snapshot/findAnomalies',
    method: 'get',
    params: data
  })
}




// WEBPACK FOOTER //
// ./src/api/assetSnapshot.js